// extracted by mini-css-extract-plugin
export default {"wrapper":"QrModal_wrapper__H1bNb","code":"QrModal_code__85bIb","bottom":"QrModal_bottom__PSTh3","bot":"QrModal_bot__9IJAX"};